import React from 'react';
import styles from './Footer.module.css';

const Footer = ({ onNavigate }) => {

  const contactButtons = [
    {
      text: 'Call Us',
      href: 'tel:+447751980456',
      external: false
    },
    {
      text: 'Message Us',
      href: 'https://wa.me/447751980456',
      external: true
    },
    {
      text: 'Email Us',
      href: 'mailto:thequeenshotelharlech@gmail.com',
      external: false
    },
    {
      text: 'Find Us',
      href: 'https://maps.google.com/?q=52.861536582270524,-4.110125222048405',
      external: true
    },
    {
      text: 'Follow Us',
      href: 'https://www.facebook.com/thequeensbarharlech/?locale=en_GB',
      external: true
    },
    {
      text: 'Stay With Us',
      href: 'https://www.booking.com/hotel/gb/the-queens-harlech.en-gb.html',
      external: true
    }
  ];

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles['footer-content']}>
          <div className={styles['footer-left']}>
            <h3>The Queens Hotel Harlech</h3>
            <p>Castell Morfa</p>
            <p>Harlech</p>
            <p>LL46 2UF</p>
          </div>
          <div className={styles['footer-buttons']}>
            {contactButtons.map((button, index) => (
              <a
                key={index}
                href={button.href}
                className={styles['footer-btn']}
                target={button.external ? '_blank' : undefined}
                rel={button.external ? 'noopener noreferrer' : undefined}
              >
                {button.text}
              </a>
            ))}
          </div>
          <div className={styles['footer-bottom']}>
            <div className={styles['footer-copyright']}>
              © 2025 The Queens Hotel Harlech. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;